import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";
// import variableEffects from '@/base/global/variables/figma.effects.json';

export const resultThemeToken: any = {
  //===================== COLOR =========================//
  colorTextDescription: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorTextHeading: variableColors["ColorFigmaNeutralGrayscaleGray90"],

  //===================== FONT =========================//
  subtitleFontSize: variableTypography["BodyLargeFontSize"],
  subtitleFontWeight: variableTypography["BodyLargeFontWeight"],
  titleFontSize: variableTypography["BodyH500FontSize"],
  titleFontWeight: variableTypography["BodyH500FontWeight"],

  //===================== SIZE =========================//
  marginXS: 16,
  paddingLG: 24,
  paddingXL: 0,
  lineHeight: 1,
  lineHeightHeading3: 1,
};
